export default "__VITE_ASSET__CYHQ7sBJ__"